export var dataHooks = {
  title: 'PromotionalModal-title',
  subtitle: 'PromotionalModal-subtitle',
  content: 'PromotionalModal-content',
  secondaryButton: 'PromotionalModal-secondaryButton',
  primaryButton: 'PromotionalModal-primaryButton',
  illustration: 'PromotionalModal-illustration',
  illustrationSrc: 'PromotionalModal-illustrationSrc'
};